export class QuotationInfo {
  QuotationID: number
  QuotationNo: string
  QuotationCompanyID: number
  QuotationCompanyCode: string
  QuotationCompanyName: string
  QuotationTenantID: number
  QuotationTenantCode: string
  QuotationTenantName_TH: string
  QuotationTenantName_EN: string
  QuotationProjectSaleID: number
  QuotationProjectSaleCode: string
  QuotationProjectSaleName: string
  QuotationValidDate: string
  QuotationCreateDate: string
  QuotationCreateBy: string
  QuotationUpdateDate: string
  QuotationUpdateBy: string
  QuotationFlagDelete: string
  rowFetch: number
  rowOFFSet: number
  itemTotal: number
}
